let map;
let marker;
let currentParentTab = null;

document.addEventListener('DOMContentLoaded', function() {
  const firstLocation = document.querySelector('[data-location][data-lat][data-lng]');
  const defaultLat = firstLocation ? parseFloat(firstLocation.dataset.lat) : 43.6532;
  const defaultLng = firstLocation ? parseFloat(firstLocation.dataset.lng) : -79.3832;

  map = L.map('map-tabs-map').setView([defaultLat, defaultLng], 13);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19
  }).addTo(map);

  marker = L.marker([defaultLat, defaultLng]).addTo(map);

  const firstParentTab = document.querySelector('[data-parent-tab]');
  if (firstParentTab) {
    currentParentTab = firstParentTab.dataset.parentTab;
  }

  setTimeout(function() {
    map.invalidateSize();
  }, 100);
});

function switchParentTab(parentTabId) {
  document.querySelectorAll('.map-tabs-parent-tab').forEach(tab => {
    tab.classList.remove('active');
    if (tab.dataset.parentTab === parentTabId) {
      tab.classList.add('active');
    }
  });

  document.querySelectorAll('.map-tabs-parent-content').forEach(content => {
    content.classList.remove('active');
    if (content.dataset.parentContent === parentTabId) {
      content.classList.add('active');
    }
  });

  currentParentTab = parentTabId;

  const firstSubTab = document.querySelector(`.map-tabs-parent-content[data-parent-content="${parentTabId}"] .map-tabs-sub-tab`);
  if (firstSubTab) {
    const locationId = firstSubTab.dataset.location;
    const lat = parseFloat(firstSubTab.dataset.lat);
    const lng = parseFloat(firstSubTab.dataset.lng);
    switchLocation(locationId, lat, lng);
  }
}

function switchLocation(locationId, lat, lng) {
  const currentParentContent = document.querySelector(`.map-tabs-parent-content[data-parent-content="${currentParentTab}"]`);
  if (currentParentContent) {
    currentParentContent.querySelectorAll('.map-tabs-sub-tab').forEach(tab => {
      tab.classList.remove('active','open');
      if (tab.dataset.location === locationId) {
        tab.classList.add('active', 'open');
      }
    });

    currentParentContent.querySelectorAll('.map-tabs-location-info').forEach(info => {
      if (info.dataset.locationInfo === locationId) {
        info.style.display = 'flex';
      } else {
        info.style.display = 'none';
      }
    });
  }

  if (map && marker && lat && lng) {
    map.flyTo([lat, lng], 15, {
      duration: 1.5,
      easeLinearity: 0.25
    });
    marker.setLatLng([lat, lng]);
  }
}